import React from 'react';
import '../homeComponents/css/hero.css';

export default function HeroBanner() {
  return (
    <section className="heroContainer home-hero1 heroContainer--inner">
      <div className="heroWrapper">
        <div className="heroLeft">
          <h1 className="heroTitle">Tailor made packages for your needs</h1>
        </div>
      </div>
    </section>
  );
}
